/* eslint-disable import/order */
/* eslint-disable import/first */

import VueCompositionAPI from '@vue/composition-api'
import {
  BootstrapVue,
  IconsPlugin,
  ModalPlugin,
  PopoverPlugin,
  ToastPlugin,
} from 'bootstrap-vue'
import { bindClient } from 'kometry/client'
import lodash from 'lodash'
import LottieAnimation from 'lottie-vuejs/src/LottieAnimation.vue' // import lottie-vuejs
import money from 'v-money'
import Vue from 'vue'
import VueLodash from 'vue-lodash'
import Dropdown from 'vue-simple-search-dropdown'
import App from './App.vue'
import router from './router'
import store from './store'
import { telemetry } from './telemetry.config'
import './index.css'

// Global Components
import './global-components'

// 3rd party plugins
import '@axios'
import '@helpers'
import '@/libs/acl'
import '@/libs/clipboard'
import '@/libs/toastification'
import '@/libs/sweet-alerts'
import '@/libs/vue-select'
import '@/libs/maps'
import '@/libs/geocoder'
import '@/libs/filters'
// Axios Mock Adapter
// import '@/@fake-db/db'

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)
Vue.use(PopoverPlugin)

// Composition API
Vue.use(VueCompositionAPI)
Vue.use(Dropdown)
// Lodash
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(VueLodash, { lodash })
Vue.use(money, { precision: 0 })
// Lottie Animation
Vue.use(LottieAnimation) // add lottie-animation to your global scope

// Feather font icon - For form-wizard
// * Shall remove it if not using font-icons of feather-icons - For form-wizard
require('@core/assets/fonts/feather/iconfont.css') // For form-wizard

// custom font
require('@/assets/fonts/odin-rounded/style.css')

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

const endpointAssets = endpoint => `https://storage.googleapis.com/komerce/${endpoint}`

Vue.prototype.$assets = endpointAssets

async function bootstrap() {
  const init = await telemetry.initClient()
  init.listenUnhandledErrors()
  bindClient(init.api)
  Vue.use(init.module.createPlugin())

  new Vue({
    router,
    store,
    render: h => h(App),
  }).$mount('#app')
}

bootstrap()
